import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Pagination, Col, Row, Spinner, Table } from 'react-bootstrap';
import { Button, TextField } from '@material-ui/core';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import {
  faSortAmountUp,
  faSortAmountDownAlt,
  faSyncAlt
} from '@fortawesome/free-solid-svg-icons';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import AbstentionsModal from '../../Components/Modal/AbstentionsModal';

const MyAreasContainer = styled.div`
  width: 100%;
  min-height: 300px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const SortAndFilterContainer = styled.div`
  width: 100%;
  display: flex;
  margin: 10px 0;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const FilterContainer = styled.div`
  flex: 4;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  & > * {
    margin-top: 10px;
  }
`;

const SortContainer = styled.div`
  flex-wrap: no-wrap;
  flex: 1;
  min-width: 200px;
  & > * {
    margin-top: 10px;
  }
`;
const ORDER_OPTIONS = [
  { label: 'Nome da área', value: 'label' },
  { label: 'Responsável', value: 'managerName' },
  { label: 'Respondentes', value: 'respondents' },
  { label: 'Turnover', value: 'currentTurnover' },
  { label: 'Felicidade', value: 'currentHappiness' },
  { label: 'Cultura', value: 'currentCulturalFit' },
  { label: 'Saúde', value: 'currentHealth' }
];
const MONTHS_LIST = [
  { label: 'Jan', value: 1 },
  { label: 'Fev', value: 2 },
  { label: 'Mar', value: 3 },
  { label: 'Abr', value: 4 },
  { label: 'Mai', value: 5 },
  { label: 'Jun', value: 6 },
  { label: 'Jul', value: 7 },
  { label: 'Ago', value: 8 },
  { label: 'Set', value: 9 },
  { label: 'Out', value: 10 },
  { label: 'Nov', value: 11 },
  { label: 'Dez', value: 12 }
];

const YEARS_LIST = [
  { label: '2020', value: 2020 },
  { label: '2021', value: 2021 },
  { label: '2022', value: 2022 }
];

function getMonthSelection(month) {
  return MONTHS_LIST.find(mo => mo.value == month);
}

function getYearSelection(year) {
  return YEARS_LIST.find(y => y.value == year);
}

export default function MyCourses(props) {
  const date = new Date();
  const currentMonth = date.getUTCMonth(date) + 1;
  const currentYear = date.getFullYear(date);
  const { listAreas, getAreas, getAbstentions } = props;
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [areasOptions, setAreasOptions] = useState([]);
  const [areasList, setAreasList] = useState([]);
  const [areasToGet, setAreasToGet] = useState([]);
  const [orderDirection, setOrderDirection] = useState('asc');
  const [sortField, setSortField] = useState('');
  const [month, setMonth] = useState(currentMonth);
  const [year, setYear] = useState(currentYear);
  const [dateFilter, setDateFilter] = useState('');
  const [monthFilter, setMonthFilter] = useState('');
  const [abstentionsMonthFilter, setAbstentionsMonthFilter] = useState('');
  const [textFilter, setTextFilter] = useState('');
  const [loaded, setLoaded] = useState(false);
  const [monthsRange, setMonthsRange] = useState([]);
  const [totalAreas, setTotalAreas] = useState(0);
  const [showEvasionModal, setShowEvasionModal] = useState(false);
  const [areaToGetAbstentions, setAreaToGetAbstentions] = useState([]);

  useEffect(() => {
    async function fetchData() {
      setLoaded(false);
      if (!dateFilter) {
        setMonthFilter(`${month}-${year}`);
        setAbstentionsMonthFilter(`${month}-01-${year}`);
      }
      const ITENS_PER_PAGE = 50;
      const listOfAreas = await listAreas({
        areaId: areasToGet,
        page,
        limit: ITENS_PER_PAGE,
        filters: {
          date: dateFilter,
          label: textFilter
        },
        sort: {
          fieldName: sortField,
          direction: orderDirection
        }
      });

      const listOfOptionsAreas = await getAreas({});
      setAreasOptions(listOfOptionsAreas);
      const { data = [], count } = listOfAreas; // change default count after refactor fiter-backend
      const referenceData = data.length > 0 ? data[0] : [];
      setMonthsRange(
        referenceData?.healthScores
          ? referenceData?.healthScores.map(({ reference }) => reference)
          : []
      );
      setAreasList(data);
      setPages(Math.ceil(count / ITENS_PER_PAGE));
      setTotalAreas(count);
      setLoaded(true);
    }
    fetchData();
  }, [
    areasToGet,
    dateFilter,
    getAreas,
    listAreas,
    month,
    orderDirection,
    page,
    sortField,
    textFilter,
    year
  ]);

  function changeDate(monthValue, yearValue) {
    setMonth(monthValue);
    setYear(yearValue);
    if (monthValue && yearValue) {
      setDateFilter(`${monthValue}/${yearValue}`);
      setMonthFilter(`${monthValue}-${yearValue}`);
      setAbstentionsMonthFilter(`${monthValue}-01-${yearValue}`);
    }
  }
  const changeSearchText = AwesomeDebouncePromise(async searchValue => {
    setTextFilter(searchValue);
  }, 800);

  const handleShowEvasionList = area => {
    setAreaToGetAbstentions([{ value: area }]);
    setShowEvasionModal(true);
  };

  const getRespondentsColor = percentage => {
    if (percentage >= 60) return 'forca';
    if (percentage >= 40 && percentage < 60) return 'neutro';
    if (percentage < 60) return 'pd';
  };

  return (
    <>
      <AbstentionsModal
        getAbstentions={getAbstentions}
        show={showEvasionModal}
        setShow={setShowEvasionModal}
        monthFilter={abstentionsMonthFilter}
        areasList={areaToGetAbstentions}
      />
      <div className="mycourses-container">
        <SortAndFilterContainer>
          <FilterContainer>
            <Col className="col-md-4" style={{ minWidth: '200px' }}>
              {/* <Select
                isMulti
                options={areasOptions}
                placeholder="Buscar Área"
                onChange={e => setAreasToGet(e.map(el => el.id))}
              /> */}
              <TextField
                fullWidth
                placeholder="Buscar Área"
                onChange={e => changeSearchText(e.target.value)}
              />
            </Col>

            <Row className="col-md-4">
              <Col md={6} style={{ maxWidth: '150px' }}>
                <Select
                  defaultValue={getMonthSelection(month)}
                  options={MONTHS_LIST}
                  className="select-filter"
                  placeholder="Mês"
                  onChange={e => changeDate(e.value, year)}
                />
              </Col>
              <Col md={6} style={{ maxWidth: '150px' }}>
                <Select
                  defaultValue={getYearSelection(year)}
                  options={YEARS_LIST}
                  className="select-filter"
                  placeholder="Ano"
                  onChange={e => changeDate(month, e.value)}
                />
              </Col>
            </Row>
          </FilterContainer>
          <SortContainer>
            <Row className="col-md-12">
              <Col md={10} style={{ maxWidth: '350px' }}>
                <Select
                  options={ORDER_OPTIONS}
                  className="select-filter"
                  onChange={e => setSortField(e.value)}
                  placeholder="Ordenação"
                />
              </Col>
              <Col md={2} style={{ maxWidth: '40px' }}>
                <Button
                  onClick={() =>
                    setOrderDirection(orderDirection === 'asc' ? 'desc' : 'asc')
                  }
                >
                  <FontAwesomeIcon
                    icon={
                      orderDirection === 'asc'
                        ? faSortAmountDownAlt
                        : faSortAmountUp
                    }
                  />
                </Button>
              </Col>
            </Row>
          </SortContainer>
        </SortAndFilterContainer>

        <Table
          style={{ zIndex: 0 }}
          responsive
          bordered
          className="fixed-columns tableFixHead"
        >
          <thead style={{ zIndex: 0 }}>
            <tr>
              <th className="name-header" />
              <th style={{ textAlign: 'center' }} colSpan={6}>
                Felicidade{' '}
              </th>
            </tr>
            <tr>
              <td className="name-header">Área</td>

              {monthsRange.map(monthScore => (
                <td style={{ textAlign: 'center' }} className="name-header">
                  {monthScore}
                </td>
              ))}
            </tr>
          </thead>
          {!loaded ? (
            <div className="table-spinner d-flex justify-content-center">
              <div className="spinner-border" />
            </div>
          ) : (
            <tbody>
              {areasList.map(area => (
                <tr id={area.id}>
                  <td>
                    <p
                      style={{
                        width: '250px'
                      }}
                    >
                      <Link
                        style={{ width: '100%', wordWrap: 'normal' }}
                        to={`/board/${area.id}/${monthFilter}`}
                      >
                        {' '}
                        {area.label}
                      </Link>
                    </p>
                    {/* <OverlayTrigger style={{width:600+'px', height:800+'px'}}  trigger={['hover', 'focus']} placement="auto" overlay={popover(area.label, '#82ca9d', 'Taxa de Felicidade', 'happiness')> */}
                    <span>
                      Saúde: {area.currentHealthScore}% <br />
                    </span>

                    <span>
                      Felicidade: {area.currentHappiness}% <br />
                    </span>
                    {/* </OverlayTrigger> */}
                    {/* <OverlayTrigger trigger={['hover', 'focus']} placement="auto" overlay={popover(area.label, '#8884d8', 'Taxa de aderência à cultura', 'fit')}> */}
                    <span>
                      Cultura: {area.currentCulturalFit}%<br />
                    </span>
                    {/* </OverlayTrigger> */}

                    <span>
                      Turnover: {area.currentTurnover}%<br />
                    </span>

                    <span
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleShowEvasionList(area.id)}
                    >
                      Respondentes:{' '}
                      <span className={getRespondentsColor(area.respondents)}>
                        {' '}
                        {area.respondents}%{' '}
                      </span>{' '}
                      <br />
                    </span>

                    <b>{area.manager.name}</b>
                    <br />
                  </td>
                  {area.healthScores.map(scores => (
                    <td
                      style={{ verticalAlign: 'middle', textAlign: 'center' }}
                    >
                      {scores.value}%
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          )}
        </Table>
        <Pagination>
          {pages > 1 ? (
            <Pagination.Prev
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            />
          ) : (
            <></>
          )}
          <Pagination.Item active={page === 1} onClick={() => setPage(1)}>
            1
          </Pagination.Item>

          {pages > 2 && page !== 1 && page !== pages ? (
            <>
              {page !== 1 ? <Pagination.Ellipsis disabled /> : <></>}
              <Pagination.Item active>{page}</Pagination.Item>
              {page !== pages - 2 ? <Pagination.Ellipsis disabled /> : <></>}
            </>
          ) : (
            <Pagination.Ellipsis disabled />
          )}

          {pages > 1 ? (
            <>
              <Pagination.Item
                active={page === pages}
                onClick={() => setPage(pages)}
              >
                {pages}
              </Pagination.Item>
              <Pagination.Next
                disabled={page === pages}
                onClick={() => setPage(page + 1)}
              />
            </>
          ) : (
            <></>
          )}
        </Pagination>
      </div>
    </>
  );
}
